export const departmentCenters = {
    '01': { lat: 46.25, lng: 5.75 }, // Ain
    '02': { lat: 49.5, lng: 3.5 }, // Aisne
    '03': { lat: 46.3333, lng: 3.25 }, // Allier
    '04': { lat: 44.0833, lng: 6.25 }, // Alpes-de-Haute-Provence
    '05': { lat: 44.6667, lng: 6.25 }, // Hautes-Alpes
    '06': { lat: 43.6667, lng: 7.0 }, // Alpes-Maritimes
    '07': { lat: 44.75, lng: 4.5 }, // Ardèche
    '08': { lat: 49.6667, lng: 4.75 }, // Ardennes
    '09': { lat: 42.9167, lng: 1.5833 }, // Ariège
    10: { lat: 48.3333, lng: 4.0833 }, // Aube
    11: { lat: 43.0833, lng: 2.5 }, // Aude
    12: { lat: 44.3333, lng: 2.5833 }, // Aveyron
    13: { lat: 43.5, lng: 5.25 }, // Bouches-du-Rhône
    14: { lat: 49.0833, lng: -0.3333 }, // Calvados
    15: { lat: 45.0333, lng: 2.6667 }, // Cantal
    16: { lat: 45.6667, lng: 0.25 }, // Charente
    17: { lat: 45.75, lng: -0.75 }, // Charente-Maritime
    18: { lat: 47.0, lng: 2.5 }, // Cher
    19: { lat: 45.3333, lng: 1.75 }, // Corrèze
    21: { lat: 47.5, lng: 4.75 }, // Côte-d'Or
    22: { lat: 48.5, lng: -2.75 }, // Côtes-d'Armor
    23: { lat: 46.0833, lng: 2.0 }, // Creuse
    24: { lat: 45.0, lng: 0.75 }, // Dordogne
    25: { lat: 47.25, lng: 6.25 }, // Doubs
    26: { lat: 44.75, lng: 5.25 }, // Drôme
    27: { lat: 49.0, lng: 1.0 }, // Eure
    28: { lat: 48.3333, lng: 1.3333 }, // Eure-et-Loir
    29: { lat: 48.1667, lng: -4.0 }, // Finistère
    '2A': { lat: 41.9167, lng: 8.75 }, // Corse-du-Sud
    '2B': { lat: 42.5, lng: 9.0 }, // Haute-Corse
    30: { lat: 44.0, lng: 4.0 }, // Gard
    31: { lat: 43.5, lng: 1.5 }, // Haute-Garonne
    32: { lat: 43.6667, lng: 0.5 }, // Gers
    33: { lat: 44.75, lng: -0.5 }, // Gironde
    34: { lat: 43.6667, lng: 3.25 }, // Hérault
    35: { lat: 48.1667, lng: -1.6667 }, // Ille-et-Vilaine
    36: { lat: 46.75, lng: 1.6667 }, // Indre
    37: { lat: 47.3333, lng: 0.6667 }, // Indre-et-Loire
    38: { lat: 45.25, lng: 5.75 }, // Isère
    39: { lat: 46.75, lng: 5.75 }, // Jura
    40: { lat: 44.0, lng: -1.0 }, // Landes
    41: { lat: 47.5, lng: 1.3333 }, // Loir-et-Cher
    42: { lat: 45.75, lng: 4.25 }, // Loire
    43: { lat: 45.0833, lng: 3.8333 }, // Haute-Loire
    44: { lat: 47.3333, lng: -1.6667 }, // Loire-Atlantique
    45: { lat: 47.8333, lng: 2.0 }, // Loiret
    46: { lat: 44.6667, lng: 1.6667 }, // Lot
    47: { lat: 44.5, lng: 0.5 }, // Lot-et-Garonne
    48: { lat: 44.5, lng: 3.5 }, // Lozère
    49: { lat: 47.5, lng: -0.3333 }, // Maine-et-Loire
    50: { lat: 49.0833, lng: -1.3333 }, // Manche
    51: { lat: 49.0, lng: 4.25 }, // Marne
    52: { lat: 48.25, lng: 5.25 }, // Haute-Marne
    53: { lat: 48.1667, lng: -0.6667 }, // Mayenne
    54: { lat: 48.75, lng: 6.25 }, // Meurthe-et-Moselle
    55: { lat: 49.0, lng: 5.25 }, // Meuse
    56: { lat: 47.75, lng: -2.8333 }, // Morbihan
    57: { lat: 49.0, lng: 6.25 }, // Moselle
    58: { lat: 47.0, lng: 3.5 }, // Nièvre
    59: { lat: 50.5, lng: 3.5 }, // Nord
    60: { lat: 49.4167, lng: 2.5 }, // Oise
    61: { lat: 48.5, lng: 0.25 }, // Orne
    62: { lat: 50.5, lng: 2.5 }, // Pas-de-Calais
    63: { lat: 45.75, lng: 3.25 }, // Puy-de-Dôme
    64: { lat: 43.3333, lng: -0.75 }, // Pyrénées-Atlantiques
    65: { lat: 43.0833, lng: 0.1667 }, // Hautes-Pyrénées
    66: { lat: 42.5, lng: 2.75 }, // Pyrénées-Orientales
    67: { lat: 48.6667, lng: 7.5 }, // Bas-Rhin
    68: { lat: 47.75, lng: 7.25 }, // Haut-Rhin
    69: { lat: 45.75, lng: 4.75 }, // Rhône
    70: { lat: 47.6667, lng: 6.1667 }, // Haute-Saône
    71: { lat: 46.6667, lng: 4.5 }, // Saône-et-Loire
    72: { lat: 48.0, lng: 0.25 }, // Sarthe
    73: { lat: 45.5, lng: 6.5 }, // Savoie
    74: { lat: 46.0, lng: 6.5 }, // Haute-Savoie
    75: { lat: 48.8566, lng: 2.3522 }, // Paris
    76: { lat: 49.5, lng: 1.25 }, // Seine-Maritime
    77: { lat: 48.6667, lng: 2.75 }, // Seine-et-Marne
    78: { lat: 48.75, lng: 1.8333 }, // Yvelines
    79: { lat: 46.5, lng: -0.25 }, // Deux-Sèvres
    80: { lat: 50.0, lng: 2.25 }, // Somme
    81: { lat: 43.75, lng: 2.25 }, // Tarn
    82: { lat: 44.0, lng: 1.25 }, // Tarn-et-Garonne
    83: { lat: 43.4167, lng: 6.0 }, // Var
    84: { lat: 44.0, lng: 5.0 }, // Vaucluse
    85: { lat: 46.6667, lng: -1.5 }, // Vendée
    86: { lat: 46.5833, lng: 0.3333 }, // Vienne
    87: { lat: 45.8333, lng: 1.25 }, // Haute-Vienne
    88: { lat: 48.25, lng: 6.8333 }, // Vosges
    89: { lat: 47.8333, lng: 3.5 }, // Yonne
    90: { lat: 47.6667, lng: 6.8333 }, // Territoire de Belfort
    91: { lat: 48.5, lng: 2.25 }, // Essonne
    92: { lat: 48.8954, lng: 2.2479 }, // Hauts-de-Seine
    93: { lat: 48.9167, lng: 2.4167 }, // Seine-Saint-Denis
    94: { lat: 48.75, lng: 2.4667 }, // Val-de-Marne
    95: { lat: 49.0833, lng: 2.25 }, // Val-d'Oise
    971: { lat: 16.265, lng: -61.550999 }, // Guadeloupe
    972: { lat: 14.641528, lng: -61.024174 }, // Martinique
    973: { lat: 4.938, lng: -52.335 }, // Guyane
    974: { lat: -21.13, lng: 55.53 }, // La Réunion
    976: { lat: -12.8275, lng: 45.166244 } // Mayotte
};
